import { UPDATE_FETCH_MODE } from './meta-state-actions';
export const createMetaStateReducer = ({ initialFetchMode }) => {
    return (state = {
        fetchMode: initialFetchMode,
    }, action) => {
        switch (action.type) {
            case UPDATE_FETCH_MODE: {
                return {
                    ...state,
                    fetchMode: action.payload,
                };
            }
            default:
                return state;
        }
    };
};
//# sourceMappingURL=meta-state-reducer.js.map